import React, { useEffect } from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { RadioGroupField } from '../../../components/Form';
import { useField } from 'react-final-form';
import { t } from '@bay-email/core';

const options = [
	{
		value: 'normal',
		get label() {
			return t('Wrap');
		},
	},
	{
		value: 'nowrap',
		get label() {
			return t('No wrap');
		},
	},
];

export function TextWrap({ name }: { name?: string }) {
	const { focusIdx } = useFocusIdx();

	const fieldName = name || `${focusIdx}.attributes.white-space`;
	const { input } = useField<string | undefined>(fieldName, {
		subscription: {
			value: true,
		},
	});

	useEffect(() => {
		if ((input.value === undefined || input.value === '') && focusIdx) {
			input.onChange('normal');
		}
	}, [focusIdx, input]);

	return (
		<RadioGroupField
			label={t('Text wrap')}
			name={fieldName}
			options={options}
			type='button'
			formItem={{ style: { marginBottom: '8px' } }}
		/>
	);
}
